<template>
  <TransitionRoot as="template" :show="generalStore.isSearchDrawerOpen">
    <Dialog
      ref="dialog"
      as="div"
      class="relative z-[999]"
      @close="closeWithDelay"
    >
      <div class="fixed inset-0 top-0 overflow-hidden">
        <div class="absolute inset-0 top-0 overflow-hidden">
          <div
            class="pointer-events-none fixed bottom-0 right-0 top-0 flex max-w-full"
          >
            <TransitionChild
              as="template"
              enter="transform transition ease-in-out duration-250"
              enter-from="translate-x-full"
              enter-to="translate-x-0"
              leave="transform transition ease-in-out duration-250"
              leave-from="translate-x-0"
              leave-to="translate-x-full"
              @after-enter="onAfterEnter"
            >
              <DialogPanel
                class="pointer-events-auto relative w-screen md:max-w-[420px]"
              >
                <div
                  class="flex h-full flex-col overflow-auto bg-primary shadow-xl"
                >
                  <div
                    class="border-b-white flex items-center justify-between border-b bg-primary px-4 py-3 sticky top-0 z-1"
                  >
                    <DialogTitle class="ui-text-xs text-white">
                      {{ $t("search") }}
                    </DialogTitle>
                    <UiButton
                      variant-type="icon"
                      variant="clear"
                      size="xs"
                      :aria-label="
                        $t('ariaLabelClose', { title: $t('search') })
                      "
                      @click="generalStore.isSearchDrawerOpen = false"
                    >
                      <UiIcon name="close" class="size-6 text-white" />
                    </UiButton>
                  </div>
                  <div>
                    <LazyCommonAppHeaderSearchProductsGrid
                      @result-item-click="closeWithDelay"
                      @goToSearchPage="goToSearchPageHandlerLocal"
                    />
                  </div>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { onClickOutside } from "@vueuse/core";

const generalStore = useGeneralStore();
const { goToSearchPageHandler } = useGoToSearchPage();
const generalInternalStore = useGeneralInternalStore();
const dialog = ref(null);

onClickOutside(dialog, () => {
  closeWithDelay();
});

watch(
  () => generalStore.isSearchDrawerOpen,
  (val) => {
    generalInternalStore.systemOverlay = val;
  },
);

function onAfterEnter() {
  setTimeout(() => {
    const inertEl = document.querySelector("[inert]");
    if (inertEl) {
      inertEl.removeAttribute("inert");
    }
  }, 0);
}

function closeWithDelay() {
  setTimeout(() => {
    generalStore.isSearchDrawerOpen = false;
  }, 0);
}

function goToSearchPageHandlerLocal(searchValue: string) {
  goToSearchPageHandler(searchValue);
  generalStore.isSearchDrawerOpen = false;
}
</script>
